<template>
  <div style="background-image: linear-gradient(70deg, #eae0d0 , #f6f3ec, #eae0d0);" >

  <header>
      
    <div style="width: 100%; overflow: hidden;">
      <div style="width: 10%; float: left;">
          <img src="../assets/img_tipo_e.png" alt="" width="80%" align="left" class="figlado"/>

      </div>
      
      <div style="width: 80%;  float: left;margin-top:5%"> 
          <div class="container">
          <div class="logomarca">
            <img src="../assets/marca_top_parque.png"  style="max-width:90%"  alt="" />
          </div>
          <div class="text">
            <h1>Velórios Virtuais</h1>
            <h3>Você próximo no sentimento.</h3>
          </div>
        </div>
      </div>
      
      <div style="width: 10%;  float: left;"> 
          <img src="../assets/img_tipo_d.png" alt="" width="100%" align="right" class="figlado"/>
      </div>
    </div>


    </header>

    <div style="width: 100%; overflow: hidden;">
      <div style="width: 10%; float: left;height: 100vh;padding-top:60vh;">
      </div>
      
      <div style="width: 80%;  float: left;"> 
          <section class="s-hero">
              <iframe 
            src="https://www.adiau.net/validacao/index.php?ipc=1682704302&id=168&token=7a735cbd238622fbf58166ab63865aba&color1=9fc1d7&color2=******&color3=******&color4=******&color5=******#"
                title="Velório Virtual"
                frameborder="0" style="width:100%;height:80vh;background-color:#9fc1d7"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
          </section>
      </div>
      
      <div style="width: 10%;  float: left;height: 100vh;"> 
          <img src="../assets/img_parque_ldc.png" alt="" width="50%" align="right" class="figlado"/>
      </div>
    </div>




<!--

  <div class="contact">
            <img src="../assets/buque-de-flores.png" alt="" />
            <h3>Floricultura:</h3>
            <p>Telefone para vendas:</p>
            <span>(82) 9.9999-9999</span>
          </div>
-->
   <section class="s-contact">
      <div class="container">
        <div class="contacts-left">
         <div class="contact">
            <div style="width: 370px; overflow: hidden;margin-left:16px">
              <div style="width: 25%; float: left;">
                <img src="../assets/flores_memorial_icone.png" alt="" />
              </div>
              <div style="width: 75%;  float: left;text-align:left;"> 
                  <h3>FLORICULTURA - </b> </br> A FLOR DO CAFÉ</h3><BR/>
                  <p>TELEFONE PARA VENDAS</p>
                  <span>(82) 99969-2001</span>
              </div>
            </div>     
          </div>
        </div>

        <div class="contacts-right">
          <div class="contact">

            <div style="width: 370px; overflow: hidden;margin-left:16px">
              <div style="width: 25%; float: left;">
                <img src="../assets/check_memorial_icone.png" alt="" />
              </div>
              <div style="width: 75%;  float: left;"> 
                <h3>PLANOS - CAMPO SANTO </br> PARQUE DAS FLORES</h3><BR/>
                <p>CENTRAL DE ATENDIMENTO:</p>
                <span>(82) 99641-3637</span>
              </div>
            </div>  

          </div>

        </div>
      </div>
    </section>
      <div> 
         <hr>
      </div>
    <footer>
      <div class="container">
      <div class="social">
        <div class="icones">

            <v-btn href="https://api.whatsapp.com/send?phone=5582996413637&text=Acesso%20via%20site%3A%20Ol%C3%A1%2C%20quero%20entrar%20em%20contato%20com%20o%20Campo%20Santo%20Parque%20das%20Flores" target="_blank" color="#9fc1d7" fab  x-large  dark>
              <v-icon>mdi-whatsapp</v-icon>
            </v-btn>

            <v-btn href="https://www.instagram.com/parquedasflores_/" target="_blank" color="#9fc1d7" fab  x-large  dark>
              <v-icon>mdi-instagram</v-icon>
            </v-btn>

            <v-btn href="https://pt-br.facebook.com/parquedasfloresmaceio/"  target="_blank" color="#9fc1d7" fab  x-large  dark>
              <v-icon>mdi-facebook</v-icon>
            </v-btn>

        </div>
      </div>
      </div>
    <div style="overflow: hidden;">
      
      <div style="width: 2%; float: left;" >
        <img src="../assets/img_parque_baixo_e.png" alt="" align="left" class="figlado"/>
      </div>
      
      <div style="width:96%;  float: left;"> 
            
           <div class="container">
            
                <div class="social">
                  <div class="text">
                    <p>AVENIDA DURVAL DE GOES MONTEIRO, S/N TABULEIRO DOS MARTINS </br> MACEIO, BRASIL CEP 57061-110</p>
                    <p>{{ new Date().getFullYear() }} -<strong> CAMPO SANTO PARQUE DAS FLORES</strong></p>
                  </div>
              </div>
          
            </div>

        </div>
      
      <div style="width: 2%;  float: left;"> 
          <img src="../assets/img_parque_baixo_d.png" alt="" align="right" class="figlado"/>
      </div>

    </div>
    </footer>

  </div>  
</template>

<script>

export default {

data: () => ({
      //color: 'background-color:#f5f5f5;',
            icons: [
                //'mdi-facebook',
                //'mdi-whatsapp',
                //'mdi-instagram',
            ],

  }),



}
</script>

<style scoped> 
*{
  --background: url('../assets/fundo_button_memorial.png');
  padding:0;
  list-style:none;
  text-decoration:none;
  outline:none;
  border:none;
  box-sizing:border-box
  }

  hr{
  border: 2px solid orange;
  border-radius: 5px;
  width:50%;
  margin-left:25%;

  }


  @media screen and (max-width: 1000px) {
    .logomarca{
      max-width:200px
    }    
  }  
    .logomarca{
      width:240px;
    }

  img{
    display:block;
    line-height: normal;
    }
  html{
    font-size:22.5%
    }


 
  @media (max-width: 1300px){
    
    html{
      font-size:18%
      }
  }
  @media (max-width: 90px){
     
    html{
      font-size:1.5%
      }
  }@media (max-width: 20px){
    html{
      font-size:28%
      }
  }
  html,body{
    overflow-x:hidden
    }
  button{
    background-color:transparent;
    cursor:pointer
  }
  .container{
    width:100%;
    max-width:147rem;
    padding:1.5rem;
    color:#464646; 
   margin:0 auto
  }
  header{
    padding:0rem 0;
  }
  header .container{
    display:flex;
    flex-direction:row;
    align-items:center;
    justify-content:space-between;
  }
  header .container .text h1{
    text-transform:uppercase;
    font-size:2.8rem;
    margin-bottom:0.1rem;
    text-align:center;
        letter-spacing:0.2rem;
    font-family:"coldiac";

  }
  header .container .text h3{
    font-size:1.3rem;
    color: white;
    text-align:center;
    background:#9fc1d7;
    letter-spacing:0.1rem;
    font-family:"coldiac";

  }
  @media (max-width:485px){ .figlado{ visibility: hidden; } }
  @media (max-width: 100px){
    header .container{
      flex-direction:column;}
  }
  @media (max-width: 480px){
    header .container .text h1{
      font-size:1.2rem
    }
    header .container .text h3{
      font-size:1rem;
      }
    }

    footer{
      position:relative;

      padding-bottom:0
    }
    footer .container{
      display:flex;
      flex-direction:row;
      align-items:center;
      justify-content:center;
      padding-bottom:0;
      height:12rem
    }
    footer .container .img-left{
      position:absolute;
      bottom:0;
      left:0
    }
    footer .container .img-right{
      position:absolute;
      bottom:0;
      right:0
    }
    footer .container .social{
      width:50%
    }
    footer .container .social .icones{
      display:flex;
      flex-direction:row;
      align-items:center;
      justify-content:space-around;
      width:100%
    }
    footer .container .social .icones .icone{
      background:#0a5587;
      width:74px;
      height:74px;
      padding:1.2rem;
      border-radius:25%
      }
      footer .container .social .text{
        margin-top:0.1rem
      }
      footer .container .social .text p{
        text-align:center;
        font-size:1rem;
        font-family:'coldiac';
        color:#464646;
        letter-spacing:0.2rem
      }
      footer .container .social .text p:last-child{
        margin-top:1rem
      }
      @media (max-width: 1160px){
        footer .container{
          height:55rem
        }
        footer .container .img-left,footer .container .img-right{
          max-width:25%
          }
        footer .container .social .text p{
          font-size:1rem
        }
      }
      
      @media (max-width: 480px){
        footer .container{
          height:12rem
        }
        footer .container .social{
          width:100%
        }
      }
      .s-hero .container{
        display:flex;
        flex-direction:row;
        align-items:center;
        justify-content:center;
        padding:2rem 0;
      }
      
      .s-hero .container iframe{
        width:100%;max-width:98%;height:45rem;
      }

      .s-contact{
        padding:1rem 0
      }
      .s-contact .container{
        display:flex;
        flex-direction:row;
        align-items:center;
        justify-content:space-around
      }
      .s-contact .container .contacts-left .contact,.s-contact .container .contacts-right .contact{
        display:flex;
        flex-direction:column;
        align-items:flex-start;
        margin-bottom:0.1rem;
        padding-bottom:5rem
      }.s-contact .container .contacts-left .contact:last-child,.s-contact .container .contacts-right .contact:last-child{
        margin-bottom:0
        }.s-contact .container .contacts-left .contact img,.s-contact .container .contacts-right .contact img{
          width:96px;height:96px;margin-left:0.1rem;font-family:'coldiac';padding:0.6rem;border-radius:25%;
        }
        .s-contact .container .contacts-left .contact h3,.s-contact .container .contacts-right .contact h3{
        font-size:1.2rem;font-family:'coldiac';color:#464646;line-height: normal;text-transform:uppercase}
        .s-contact .container .contacts-left .contact p,.s-contact .container .contacts-right .contact p{
          font-size:1rem;padding-left:0.1rem;color:#464646;font-family:coldiac;margin-top:0.2rem
        }
        .s-contact .container .contacts-left .contact span,.s-contact .container .contacts-right .contact span{
          margin-left:0.1rem;font-size:1.2rem;font-family:'coldiac';color:#464646;padding:0.1rem;margin-top:0.1rem
          }
        @media (max-width: 1000px){
          .s-contact{padding:0}.s-contact .container{
            align-items:center;
            flex-direction:column;
            font-family:'coldiac';
            color:#464646;
            align-items:center;
            }
          .s-contact .container .contacts-left .contact,.s-contact .container .contacts-right .contact{
            align-items:center;margin:0
          }
          .s-contact .container .contacts-left .contact h3,.s-contact .container .contacts-right .contact h3{
            text-align:left
            }
          }
        @media (max-width: 80px){
          .s-contact .container .contacts-left .contact h3,.s-contact .container .contacts-right .contact h3{
            font-size:2rem;
            font-family:'coldiac';
            color:#464646;
            }
          }



 
    @font-face {
    font-family: 'coldiac';
    font-style: normal;
    font-weight: normal;
    src: url(../assets/fonts/Coldiac.ttf);
    }




</style>
